import { SocketMsgInterface } from '@/lib/typings';
import { rootStore } from '@/store/rootStore';
import { chatStore } from '@/store/chatStore';
import {
  scrollToBottomById,
  cancelLoading,
  handleBrowserNotification,
  isWechatBrowser,
  scrollToBottomDistance,
  showMsg,
} from '@/lib/utils';
import bus from '@/lib/bus';
import {
  getChatMsgList,
  calcListTypeStr,
  accessSession,
  getChatListByListType,
  sendAck,
  sendLog,
  handlerGroupReceiveInfo,
} from '@/lib/helpers/chat';
import { MSG_TYPE_TEXT, MSG_TYPE, sessionDispatchOptionsMap } from '../const';
import dayjs from 'dayjs';
import { ElMessage } from 'element-plus';
import { showUpdateTip } from '@/router/checkVersion';
import { useRouter } from '@/router/hook';
import { pong } from './index';
import { nextTick } from 'vue';
const stats: { [propName: string]: (data: SocketMsgInterface) => void } = {
  // 收到消息
  SendUserMsg: handleSendUserMsg,
  // 收到占位消息
  SendUserMsgPlaceholder: handleSendUserMsgPlaceholder,
  // 公众号发送回调
  SendOfficialState: handleSendMsgStatus,
  // 微信发送回调
  SendWechatWorkState: handleSendMsgStatus,
  // APP/H5发送回调
  SendAppState: handleSendMsgStatus,
  // H5消息是否已读
  ReadState: handleReadState,
  // 客户接入会话
  UserAccess: handleUserAccess,
  // 接待列表有变化
  NewUserMsg: handleNewUserMsg,
  // 同事的对话有更新
  NewTeamUserMsg: handleNewTeamUserMsg,
  // 接入成功
  AccessSuccess: handleAccessSuccess,
  // 接入后更新对应的接待列表
  AccessUpdateReceive: updateChatListContent,
  // 接入的群信息更新
  UpdateGroupInfo: handleUpdateGroupInfo,
  // 接入的群成员更新
  UpdateGroupMember: handleUpdateGroupMember,
  // 获取历史聊天记录
  ChatContent: handleChatContent,
  // 置顶
  ReceiveSetTop: handleReceiveSetTop,
  // 取消置顶
  ReceiveRemoveTop: handleReceiveRemoveTop,
  // 用户离线
  UserOffline: handleUserOffline,
  // 用户上线
  UserOnline: handleUserOnline,
  // 转接
  TransferReceive: handleTransferReceive,
  // 发起聊天后主动接入
  AgainReceive: handleAgainReceive,
  // 回收成功
  RecyclePoolUser: handleRecyclePoolUser,
  // 删除接待
  DeleteReceive: handleDeleteReceive,
  // 删除同事的对话
  DeleteTeamReceive: handleDeleteTeamReceive,
  // 撤回
  MessageReCallSuccess: handleMessageReCallSuccess,
  // 客户撤回
  UserMessageReCall: handleUserMessageReCall,
  // 翻译
  Translation: handleTranslation,
  // AI助手新消息
  AiAssistant_SendMessage: handleAiAssistantSendMessage,
  AiAssistant_ChatContent: handleAiAssistantChatContent,
  // AI助手营销心理
  AiAssistant_MarketInfo: handleAiAssistantMarketInfo,
  // AI助手营销心理更新剩余追问次数
  AiAssistant_UpdateMarketInfo: handleAiAssistantUpdateMarketInfo,
  // 前端发版
  VersionUpdate: handleVersionUpdate,
  AudioToText: handleAudioToText,
  pong: handlePong,
  Ack: handleAck,
};
export function handleMsg(data: SocketMsgInterface) {
  typeof stats[data.type] === 'function' && stats[data.type](data);
}

function handleChatContent(data: SocketMsgInterface) {
  const rootStoreEx = rootStore();
  const chatStoreEx = chatStore();
  if (data.data.is_end) {
    rootStoreEx.deleteMsgBodyMoreFlag();
  } else if (!data.data.prev_id && !data?.data?.list) {
    return ElMessage.info('暫無內容');
  }
  const session_id = data.data.session_id;
  const group_id = data.data.group_id;
  if (
    (session_id && session_id === chatStoreEx.currentChatRoomInfo.sessionId) ||
    (group_id && group_id === chatStoreEx.currentChatRoomInfo.groupId)
  ) {
    chatStoreEx.updateCurrentChatRoomMsgList(data.data.list, true);
    if (data?.data?.list?.length > 0) {
      const length = data.data.list.length;
      const lastMsg = chatStoreEx.currentChatRoomMsgList[0 + length - 1];
      bus.emit('scrollToScrollHeight', `msg-item_${MSG_TYPE_TEXT[lastMsg?.data?.type]}_${lastMsg?.data?.id}`);
    }
  }
  if (
    (session_id && session_id === chatStoreEx.accessSessionParams?.session_id) ||
    (group_id && group_id === chatStoreEx.accessSessionParams?.group_id)
  ) {
    // 清空接入会话参数
    chatStoreEx.setAccessSessionParams({});
  }
  // 拉取聊天记录上报
  if (data?.data?.log_id) {
    sendLog({
      dispatch: data.data.dispatch,
      log_id: data.data.log_id,
      event: 'chat_content_pull',
    });
  }
}

function handleAiAssistantChatContent(data: SocketMsgInterface) {
  const chatStoreEx = chatStore();
  const rootStoreEx = rootStore();
  if (data.data.is_end) {
    rootStoreEx.deleteMsgBodyMoreAIMsgFlag();
  }
  if (data.data.session_id === chatStoreEx.currentChatRoomInfo.sessionId) {
    const isLoadMore = chatStoreEx.currentChatRoomAIMsgList?.length;
    chatStoreEx.updateCurrentChatRoomAIMsgList(data.data.list, true);
    if (data.data?.list?.length > 0) {
      const length = data.data.list.length;
      const lastMsg = chatStoreEx.currentChatRoomAIMsgList[0 + length - 1];
      nextTick(() => {
        !isLoadMore && scrollToBottomById('ai-msg-body');
      });
    }
  }
}

function handleAiAssistantMarketInfo(data: SocketMsgInterface) {
  const chatStoreEx = chatStore();
  chatStoreEx.setAiAssistantMarketInfo({
    market_id: data?.data?.id || '',
    remaining: data?.data?.remaining || 0,
  });
}

function handleAiAssistantUpdateMarketInfo(data: SocketMsgInterface) {
  const chatStoreEx = chatStore();
  if (data?.data?.marketInfo?.id == chatStoreEx.aiAssistantMarketInfo?.market_id) {
    chatStoreEx.setAiAssistantMarketInfo({
      remaining: data?.data?.marketInfo?.remaining || 0,
    });
  }
}

function handleSendMsgStatus(data: SocketMsgInterface) {
  const store = chatStore();
  // 客户端发送没有content_id
  if (data?.data?.content_id) {
    store.updateSendingMsgQueue(data.data.status, data.data.content_id, data.data.reason);
    store.setMsgId(data.data.content_id, data.data.msg_id, data.data.status);
  } else if (data?.data?.session_id === store.currentChatRoomInfo?.sessionId) {
    const index = store.currentChatRoomMsgList?.findIndex((v) => v?.data?.id == data.data?.id);
    if (index !== -1 && store.currentChatRoomMsgList[index].data) {
      store.currentChatRoomMsgList[index].data.reason = data?.data?.reason || '';
      store.currentChatRoomMsgList[index].data.status = data?.data?.status;
    }
  }
}

function handleReadState(data: SocketMsgInterface) {
  const store = chatStore();
  store.updateMsgReadState(data.data.session_id);
}

function handleUserAccess(data: SocketMsgInterface) {
  const store = chatStore();
  store.updateMsgReadState(data.data.session_id, data.data.id);
}

function handleAiAssistantSendMessage(data: SocketMsgInterface) {
  const store = chatStore();
  if (data?.data?.content_id) {
    updateAIMsgContent(data);
  } else {
    store.updateCurrentChatRoomAIMsgList([data], false, 'push');
  }
  nextTick(() => {
    scrollToBottomById('ai-msg-body');
  });
}

function handleSendUserMsg(data: SocketMsgInterface) {
  const store = chatStore();
  if (data.data?.content_id) {
    store.delMsgSendMsgFailedQueue(data.data.content_id);
  }
  const session_id = data.data.session_id;
  const receive_id = data.data.receive_id;
  const group_id = data.data.group_id;
  // 有接待id时判断接待id是否一致
  if (
    !group_id &&
    receive_id &&
    store.currentChatRoomInfo?.receiveId &&
    receive_id !== store.currentChatRoomInfo?.receiveId
  )
    return;

  // 撤回操作后更新消息列表
  if (data.data?.status === 3) {
    store.updateCurrentChatRoomMsgList([data], false, 'push');
  }

  if (
    (session_id && session_id === store.currentChatRoomInfo?.sessionId) ||
    (group_id && group_id === store.currentChatRoomInfo?.groupId)
  ) {
    if (!data.data.is_me) {
      const index = store.currentChatRoomMsgList?.findIndex((v) => v?.data?.msg_id == data.data?.msg_id);
      if (index === -1) {
        store.updateCurrentChatRoomMsgList([data], false, 'push');
      } else {
        updateMsgContent(data);
      }
      if (data.data?.msg_id) {
        sendAck({
          id: data.data?.msg_id,
          dispatch: data.data?.dispatch,
        });
      }
    } else {
      updateMsgContent(data);
    }

    const dis = scrollToBottomDistance('msg-body');
    store.setShowScrollToBottom(dis > 100);
    nextTick(() => {
      if (dis < 100) {
        scrollToBottomById('msg-body');
      }
    });
    store.setCurrentChatRoomAISpeechInfo({
      ...store.currentChatRoomAISpeechInfo,
      list: [],
      source_msg: {},
      showRecommedSpeech: store.currentChatRoomAISpeechInfo?.showRecommedSpeech,
    });
  }
}

// Ack确认更新消息发送状态
function handleAck(data: SocketMsgInterface) {
  if (data?.data?.content_id) {
    const store = chatStore();
    const index = store.currentChatRoomMsgList?.findIndex(
      (v) => v?.data?.content_id == data.data.content_id && v?.data?.msg_id
    );
    if (index !== -1) {
      store.currentChatRoomMsgList[index].is_send_preview = false;
    }
  }
}

function handleSendUserMsgPlaceholder(data: SocketMsgInterface) {
  const store = chatStore();
  const session_id = data.data.session_id;
  const group_id = data.data.group_id;
  if (
    (session_id && session_id === store.currentChatRoomInfo?.sessionId) ||
    (group_id && group_id === store.currentChatRoomInfo?.groupId)
  ) {
    if (!data.data.is_me) {
      const index = store.currentChatRoomMsgList?.findIndex((v) => v?.data?.msg_id == data.data?.msg_id);
      if (index === -1) {
        store.updateCurrentChatRoomMsgList([data], false, 'push');
      }

      const dis = scrollToBottomDistance('msg-body');
      store.setShowScrollToBottom(dis > 100);
      nextTick(() => {
        if (dis < 100) {
          scrollToBottomById('msg-body');
        }
      });
      store.setCurrentChatRoomAISpeechInfo({
        ...store.currentChatRoomAISpeechInfo,
        list: [],
        source_msg: {},
        showRecommedSpeech: store.currentChatRoomAISpeechInfo?.showRecommedSpeech,
      });
    }
  }
}
let scrollTimeout: any = null;
function handleAccessSuccess(data: SocketMsgInterface) {
  handleGetUserInfo(data);
  const chatStoreEx = chatStore();
  const rootStoreEx = rootStore();
  chatStoreEx.clearCurrentChatRoomMsgList();
  rootStoreEx.initMsgBodyMoreFlag();
  getChatMsgList();
  cancelLoading();
  scrollTimeout = setTimeout(() => {
    scrollToBottomById('msg-body');
  }, 50);
}
function handleGetUserInfo(data: SocketMsgInterface) {
  const store = chatStore();
  const chatStoreEx = chatStore();
  const cache = chatStoreEx.roomInfoCache;
  const info = {
    robotSerialNo: data.data?.robot?.robot_serial_no || '',
    robotId: data.data?.robot?.id || '',
    robotCorpId: data.data?.corp?.id || '',
    // 微信客服source:7会话先取robot.name，后续IM调整更改为remark_name
    robotRemarkName: data.data?.source === 7 ? data.data?.robot?.name : data.data?.robot?.remark_name || '',
    groupSerialNo: data.data?.group?.group_serial_no || '',
    groupId: data.data?.group?.id || '',
    nickName: data.data?.user_info?.nickname || data.data?.group?.name,
    avatar: data.data?.user_info?.avatar || '',
    robotCustomerUnifyId: data.data?.user_info?.robot_customer_unify_id || '',
    GZHName: data.data?.official?.name,
    remark: data.data?.user_info?.remark,
    uid: data.data?.user_info?.uid,
    id: data.data.receive_id || data.data?.group?.id,
    members: data.data?.members || [],
    switch: data.data?.switch || [], // 可切换机器人接待列表
    status: data.data?.status,
    groupUserInfo: data.data?.group?.user_role,
    sessionId: data?.data?.session_id,
    isGroup: data.data?.group ? true : false,
    receiveId: data.data?.receive_id || '',
    source: data.data?.source,
    roomType: sessionDispatchOptionsMap[data.data?.source],
    is_offline: data.data?.user_info?.is_offline, // 是否离线
    business_model: data.data?.business_model || {}, // 业务模型:type:2-用于区分app侧
    externalUserId: data.data?.user_info?.external_user_id,
    robotProviderUserId: data.data?.robot?.provider_user_id,
    robotCorpProviderId: data.data?.robot?.corp_provider_id,
    centerUid: data.data?.user_info?.center_uid, // 中台id
    is_xiaoling: data.data?.is_xiaoling, // 区分机器人接待
    app_name: data.data?.receive_channel?.app_name || '', // 来源产品
  };
  store.setCurrentChatRoomInfo({
    ...cache,
    ...info,
  });
  // 接入会话清空话术ID
  store.setRoomInfoCache({
    ...store.roomInfoCache,
    quick_reply_id: '',
  });
  if (data.data?.is_top) {
    store.setCurrentChatRoomInfo({
      isTop: data.data.is_top,
    });
  }

  if (isWechatBrowser) {
    const router = useRouter();
    scrollTimeout = setTimeout(() => {
      nextTick(() => {
        router.push({ path: '/mChatBody', query: { from: chatStoreEx.cardFrom } });
      });
    }, 300);
  } else {
    scrollTimeout = setTimeout(() => {
      scrollToBottomById('msg-body');
    }, 500);
  }
}
// 收到用户消息，更新聊天列表内容，且推进等待队列
function handleNewUserMsg(data: SocketMsgInterface) {
  const store = chatStore();
  if (data.data?.update_receive?.content_id) {
    store.delMsgSendMsgFailedQueue(data.data.update_receive.content_id);
  }
  // 消息提醒，判断是否下发消息已存在
  let tmp = getChatListByListType('personal');
  let obj = tmp.find((item: any) => item.id == data.data?.update_receive?.id) || {};
  if (obj.created_at != data.data?.update_receive?.created_at) {
    handleBrowserNotification(data);
  }
  updateChatList(data);
  handleWaitingQueue(data);
  // 修改名称，更新当前接待
  if (obj.session_id === store.currentChatRoomInfo.sessionId && data.data?.update_receive?.nickname) {
    store.setCurrentChatRoomInfo({
      nickName: data.data.update_receive.nickname,
    });
  }
}
function handleNewTeamUserMsg(data: SocketMsgInterface) {
  newTeamUserMsgQueue.push(data);
  debounceWithNewTeamUserMsg();
}
const newTeamUserMsgQueue: SocketMsgInterface[] = [];
let newTeamUserMsgTimer: any = null;
let lastUpdateTeamUserTime = 0;
function handleNewTeamUserMsgBatch() {
  newTeamUserMsgTimer && clearTimeout(newTeamUserMsgTimer);
  newTeamUserMsgTimer = setTimeout(() => {
    debounceWithNewTeamUserMsg();
  }, 1500);
  const list = newTeamUserMsgQueue.splice(0, newTeamUserMsgQueue.length);
  for (let i = 0; i < list.length; i++) {
    const listFrom = list[i]?.data?.update_receive?.is_xiaoling ? 'robot' : 'team';
    updateChatList(list[i], listFrom);
  }
  lastUpdateTeamUserTime = dayjs().valueOf();
}
// 同事对话下发更新频率调整
function debounceWithNewTeamUserMsg() {
  if (newTeamUserMsgQueue.length > 10 || (lastUpdateTeamUserTime && lastUpdateTeamUserTime < dayjs().valueOf() - 800)) {
    handleNewTeamUserMsgBatch();
  }
}

// 更新聊天列表内容
function updateChatList(data: SocketMsgInterface, listFrom = 'personal') {
  const store = chatStore();
  store.updateChatList(listFrom, data.data.update_receive);
}
function updateChatListContent(data: SocketMsgInterface) {
  const store = chatStore();
  store.updateChatListContent(data.data.update_receive);
}

// 利用回传的消息更新发送的消息内容
function updateMsgContent(data: SocketMsgInterface) {
  const store = chatStore();
  const content_id = data.data.content_id;
  const session_id = data.data.session_id;
  const group_id = data.data.group_id;
  const index = store.currentChatRoomMsgList.findIndex(
    (msg: any) =>
      (msg.data.content_id === content_id && !msg.data.id) ||
      (data?.data?.msg_id && data?.data?.msg_id == msg?.data?.msg_id)
  );
  if (index !== -1) {
    store.currentChatRoomMsgList[index] = {
      ...data,
      is_send_preview: store.currentChatRoomMsgList[index].is_send_preview,
    };
  } else if (
    (session_id && session_id === store.currentChatRoomInfo?.sessionId) ||
    (group_id && group_id === store.currentChatRoomInfo?.groupId)
  ) {
    store.updateCurrentChatRoomMsgList([data], false, 'push');
  }
}

// 利用回传的消息更新AI助手发送的消息内容
function updateAIMsgContent(data: SocketMsgInterface) {
  const store = chatStore();
  const content_id = data.data.content_id;
  const index = store.currentChatRoomAIMsgList.findIndex(
    (msg: any) => msg.data?.content_id === content_id && !msg.data?.id
  );
  if (index !== -1) {
    store.currentChatRoomAIMsgList[index] = data;
  } else {
    store.updateCurrentChatRoomAIMsgList([data], false, 'push');
  }
}

function handleWaitingQueue(data: SocketMsgInterface) {
  const target = data.data.update_receive;
  const id = target.id;
  const is_me = target.last_msg_user_type === 1; // 发送最后一条消息用户类型  0: 用户  1: 客服;
  const store = chatStore();
  if (!store.waitingQueue.map((i) => i.id).includes(id) && !is_me) {
    store.setWaitingQueue({
      id,
      acceptedTime: String(dayjs().unix()),
    });
  } else if (store.waitingQueue.map((i) => i.id).includes(id) && is_me) {
    bus.emit('clearCardItemTimeout', id);
    store.delWaitingQueue(id);
  }
}

function handleReceiveSetTop(data: SocketMsgInterface) {
  const id = data.data.id;
  const store = chatStore();
  store.topChatItem(id);
  if (id === store.currentChatRoomInfo.id) {
    store.currentChatRoomInfo.isTop = true;
  }
  isWechatBrowser && showMsg('已添加到置顶', 'success');
}

function handleReceiveRemoveTop(data: SocketMsgInterface) {
  const id = data.data.id;
  const prevId = data.data.prev_id;
  const store = chatStore();
  store.cancelTopChatItem(id, prevId);
  if (id === store.currentChatRoomInfo.id) {
    store.currentChatRoomInfo.isTop = false;
  }
  isWechatBrowser && showMsg('已取消置顶', 'success');
}

function handleUserOffline(data: SocketMsgInterface) {
  const id = data.data?.update_receive?.id;
  const store = chatStore();
  let tmp = {
    id: id,
    is_offline: true,
  };
  store.updateChatListContent(tmp, 'personal');
  store.updateChatListContent(tmp, 'team');
}

function handleUserOnline(data: SocketMsgInterface) {
  const id = data.data?.update_receive?.id;
  const source = data.data?.update_receive?.source;
  const store = chatStore();
  let tmp = {
    id,
    is_offline: false,
  };
  store.updateChatListContent(tmp, 'personal');
  store.updateChatListContent(tmp, 'team');
  const list = getChatListByListType('personal');
  const index = list.findIndex((i: any) => i.id == id);
  const lastOnlineTime = list[index]?.lastOnlineTime;
  // 同一用户上线五分钟内只提醒一次
  const flag = !lastOnlineTime || dayjs().subtract(5, 'minute').unix() > lastOnlineTime;
  if (source && calcListTypeStr(source) === 'ip' && index !== -1 && (!lastOnlineTime || flag)) {
    handleBrowserNotification(data, 'userOnline');
    list[index].lastOnlineTime = dayjs().unix();
  }
}

function handleTransferReceive() {
  ElMessage.success('轉接成功');
  const store = chatStore();
  store.clearCurrentChatRoomInfo();
  const router = useRouter();
  if (isWechatBrowser) {
    router?.push('/mHome/chatReception');
  }
}

function handleUpdateGroupInfo(data: SocketMsgInterface) {
  const store = chatStore();
  store.setCurrentChatRoomInfo({
    nickName: data.data.group.name,
  });
  bus.emit('updateIMGroupInfo');
}

function handleUpdateGroupMember(data: SocketMsgInterface) {
  const store = chatStore();
  store.setCurrentChatRoomInfo({
    members: data.data.members,
  });
  bus.emit('updateIMGroupInfo');
}

function handleAgainReceive(data: SocketMsgInterface) {
  accessSession({
    receive_id: data.data.update_receive.id,
    group_id: data.data.update_receive.group_id,
    dispatch: data.data.update_receive.source,
  });
}

function handleRecyclePoolUser() {
  ElMessage.success('會話已被回收');
}

async function handleDeleteReceive(data: SocketMsgInterface) {
  const store = chatStore();
  const tmp = data.data.update_receive || {};
  let groupReceiveInfo = {
    group_id: 0,
    label_id: 0,
    receive_id: 0,
    receive_type: '', // team || self
  };
  const isChatPage = ['/chat'].includes(location?.pathname);
  if (tmp.group_id) {
    groupReceiveInfo = await handlerGroupReceiveInfo({
      group_id: tmp.group_id,
      receive_type: 'self',
      action: 'get',
    });
  }
  // 单聊：移除  群聊：有下一个接待ID，自动接入，没有下一个接待ID，则删除
  if (!tmp.group_id || (tmp.group_id && !groupReceiveInfo.receive_id && !tmp.labels?.length)) {
    store.deleteChatListItem({ listFrom: 'personal', id: tmp.id, groupId: tmp.group_id });
    if (tmp.id === store.currentChatRoomInfo.id) {
      store.clearCurrentChatRoomInfo();
    }
  } else if (
    (groupReceiveInfo.receive_id && store.currentChatRoomInfo.groupId === groupReceiveInfo.group_id) ||
    (!store.currentChatRoomInfo.groupId && !store.currentChatRoomInfo.sessionId && isChatPage)
  ) {
    store.setCurrentChatRoomInfo({
      receiveId: groupReceiveInfo.receive_id,
      robotId: '',
    });
    accessSession({
      receive_id: groupReceiveInfo.receive_id,
      group_id: groupReceiveInfo.group_id,
      dispatch: tmp.source,
    });
  }
}
async function handleDeleteTeamReceive(data: SocketMsgInterface) {
  const store = chatStore();
  const tmp = data.data.update_receive || {};
  let groupReceiveInfo = {
    group_id: 0,
    label_id: 0,
    receive_id: 0,
    receive_type: '', // team || self
  };
  const isTeamPage = ['/teamChat'].includes(location?.pathname);
  if (tmp.group_id) {
    groupReceiveInfo = await handlerGroupReceiveInfo({
      group_id: tmp.group_id,
      receive_type: 'team',
      action: 'get',
    });
  }
  if (!tmp.group_id || (tmp.group_id && !groupReceiveInfo.receive_id && !tmp.labels?.length)) {
    store.deleteChatListItem({ listFrom: tmp?.is_xiaoling ? 'robot' : 'team', id: tmp.id, groupId: tmp.group_id });
    if (tmp.id === store.currentChatRoomInfo.id) {
      store.clearCurrentChatRoomInfo();
    }
  } else if (
    groupReceiveInfo.receive_id &&
    store.currentChatRoomInfo.groupId === groupReceiveInfo.group_id &&
    isTeamPage
  ) {
    store.setCurrentChatRoomInfo({
      receiveId: groupReceiveInfo.receive_id,
      robotId: '',
    });
    accessSession({
      receive_id: groupReceiveInfo.receive_id,
      group_id: store.currentChatRoomInfo.groupId,
      dispatch: tmp.source,
    });
  }
}
function handleTranslation(data: SocketMsgInterface) {
  const id = data.data?.id;
  const store = chatStore();
  store.updateMsgListTranslation(id, data.data?.text);
  const index = store.currentChatRoomMsgList.findIndex((msg: any) => msg.data.id === id);
  if (index === store.currentChatRoomMsgList.length - 1) {
    nextTick(() => {
      scrollToBottomById('msg-body');
    });
  }
}
function handleMessageReCallSuccess(data: SocketMsgInterface) {
  const id = data.data?.msg_id;
  const store = chatStore();
  id && store.delMsgFromCurrentChatRoomMsgList(id) !== -1 && ElMessage.success('撤回成功');
}

function handleUserMessageReCall(data: SocketMsgInterface) {
  const id = data.data?.msg_id;
  const store = chatStore();
  const session_id = data.data.session_id;
  const group_id = data.data.group_id;
  if (
    (session_id && session_id == store.currentChatRoomInfo?.sessionId) ||
    (group_id && group_id === store.currentChatRoomInfo?.groupId)
  ) {
    id && store.updateMsgListStatus(id, data.data?.status);
  }
}

function handleVersionUpdate() {
  showUpdateTip();
}

function handleAudioToText(data: SocketMsgInterface) {
  const id = data.data?.id;
  const text = data.data?.text;
  const store = chatStore();
  id &&
    text &&
    store.updateMsgListContent(id, {
      text,
    });
}
function handlePong() {
  pong();
}
